(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-content/page-footer/assets/javascripts/scroll-stick.js') >= 0) return;  svs.modules.push('/components/tb-content/page-footer/assets/javascripts/scroll-stick.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

svs.components = svs.components || {};
svs.components.tbContent = svs.components.tbContent || {};
svs.components.tbContent.pageFooter = svs.components.tbContent.pageFooter || {};

svs.components.tbContent.pageFooter.ScrollStick = function () {
  function ScrollStick(el, container) {
    var _this = this;

    _classCallCheck(this, ScrollStick);

    this.container = container || document.getElementsByClassName('sticky-footer-container')[0];
    this.el = el || document.getElementsByClassName('sticky-footer-el')[0];
    this.prevScrollPos = window.pageYOffset || document.documentElement.scrollTop;
    this.currentScrollPos = 0;

    if (this.el && this.container) {
      window.requestAnimationFrame && window.requestAnimationFrame(function () {
        return _this.scrollUpdate();
      });
      window.addEventListener('scroll', this.onScroll.bind(this), {
        passive: true
      });
      this.positionEL(this.prevScrollPos);
    }

    this.el.classList.add('page-footer-fixed-bottom');
  }

  _createClass(ScrollStick, [{
    key: "scrollUpdate",
    value: function scrollUpdate() {
      var _this2 = this;

      this.prevScrollPos !== this.currentScrollPos && this.positionEL(this.currentScrollPos);
      this.raf = window.requestAnimationFrame(function () {
        return _this2.scrollUpdate();
      });
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      this.currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;
    }
  }, {
    key: "positionEL",
    value: function positionEL(scroll) {
      if (this.containerIsScrolledIntoView()) {
        this.el.classList.remove('page-footer-fixed-bottom');
      } else {
        this.el.classList.add('page-footer-fixed-bottom');
      }

      this.prevScrollPos = scroll;
    }
  }, {
    key: "containerIsScrolledIntoView",
    value: function containerIsScrolledIntoView() {
      return window.innerHeight >= this.container.getBoundingClientRect().bottom;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.el && this.el.classList.remove('page-footer-fixed-bottom');
      this.raf && cancelAnimationFrame(this.raf);
      window.removeEventListener('scroll', this.onScroll);
    }
  }]);

  return ScrollStick;
}();
 })(window);